export const modalOverlayStyle = (appTheme, isMobile) => ({
  position: "fixed",
  inset: 0,
  background: appTheme.overlayBackground,
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: isMobile ? "14px 12px 20px" : "24px 20px 28px",
  overflowY: "auto",
  overflowX: "hidden",
  zIndex: 1600
});

export const modalContentStyle = (appTheme, isMobile) => ({
  width: "100%",
  maxWidth: isMobile ? "96vw" : "760px",
  maxHeight: isMobile ? "calc(100vh - 28px)" : "calc(100vh - 48px)",
  overflowY: "auto",
  overflowX: "hidden",
  borderRadius: isMobile ? "26px" : "30px",
  background: appTheme.modalBackground,
  border: appTheme.cardBorder,
  boxShadow: "0 24px 60px rgba(15,23,42,0.18)",
  backdropFilter: "blur(18px) saturate(180%)",
  WebkitBackdropFilter: "blur(18px) saturate(180%)",
  animation: "fadeInModal 0.2s ease",
  WebkitOverflowScrolling: "touch",
  boxSizing: "border-box",
  scrollbarWidth: "none",
  msOverflowStyle: "none"
});